<template>
    <!-- <q-ajax-bar position="top" ref="bar" size="5px" :delay="delay" color="$secondary" /> -->
    <splash v-show="isLoading" :title="'어휘학습 준비중...'" />
    <splash v-show="isProc" title="잠시만 기다려 주세요." />
    <!-- <q-layout v-show="!isLoading" view="hHh lpR fFf"> -->
    <customHeader v-if="!isLoading" :title="props.title" @onClickBack="() => { emit('onClickEnd', null); }" />
    <q-page-container v-show="!isLoading">
        <ul class="qlist">
            <div class="question" v-html="questionHeader"></div>
            <li class="list_item" v-for="(item, index) in data">
                <div style="display: flex;flex-direction: row;">
                    <div style="display: flex;flex-direction: column;width: 100%">
                        <div style="display: flex;flex-direction: row;width: 100%;justify-content: space-between;">
                            <div style="display: flex;">
                                <div class="number">
                                    <div v-show="complete"
                                        :class="[item.correctYn === true ? 'marking-correct' : 'marking-wrong']" />
                                    {{ index + 1 }}.
                                </div>
                                <div style="font-size: 1.4em;" v-html="item.problems"></div>
                            </div>
                            <div class="icon_box">
                                <div v-show="!complete" :class="[answer &&
                                    answer.filter((item) => item.index === index + 1 && item.checked === '①').length > 0
                                    ? 'checked' : 'icon_circle']" @click="selectAnswer(index + 1, '①')">
                                        <CusButton :type="answer && answer.filter((item) => item.index === index + 1 && item.checked === '①').length === 0 ? 361 : 380"/>
                                </div>
                                <div v-show="complete && item.correctYn" :class="[answer &&
                                    answer.filter((item) => item.index === index + 1 && item.checked === '①').length > 0 ? 'checked' : 'icon_circle']">  
                                        <CusButton :type="answer && answer.filter((item) => item.index === index + 1 && item.checked === '①').length > 0 ? 391:361"/>
                                </div>
                                <div v-show="complete && !item.correctYn" :class="[answer &&
                                    answer.filter((item) => item.index === index + 1 && item.checked === '①').length === 0 ? 'icon_circle' : 'wrong_answer_circle']">
                                        <CusButton :type="answer && answer.filter((item) => item.index === index + 1 && item.checked === '①').length === 0 ? 361: 391" />
                                </div>
                                <div  v-show="!complete" :class="[answer &&
                                    answer.filter((item) => item.index === index + 1 && item.checked === '②').length > 0
                                    ? 'checked_wrong' : 'icon_circle']" @click="selectAnswer(index + 1, '②')">
                                        <CusButton :type="answer && answer.filter((item) => item.index === index + 1 && item.checked === '②').length === 0 ? 370: 390"/>
                                </div>
                                <div v-show="complete && item.correctYn" :class="[answer &&
                                    answer.filter((item) => item.index === index + 1 && item.checked === '②').length > 0 ? 'checked_wrong' : 'icon_circle']">  
                                         <CusButton :type="answer && answer.filter((item) => item.index === index + 1 && item.checked === '②').length === 0? 370 : 392"/>
                                </div>
                                <div v-show="complete && !item.correctYn" :class="[answer &&
                                    answer.filter((item) => item.index === index + 1 && item.checked === '②').length === 0 ? 'icon_circle' : 'wrong_answer_circle']">
                                        <CusButton :type="answer && answer.filter((item) => item.index === index + 1 && item.checked === '②').length === 0 ? 370: 392" />
                                </div>
                            </div>
                        </div>
                        <div class="check_answer" v-show="complete">
                            <div style="display: flex; flex-direction: row;align-items: center;">
                                <span style="font-weight: 700;font-size: 1.2em">정답</span>
                                <div :class="item.correct !== '②' ? 'checked_small' : 'checked_small_wrong'">
                                    <q-icon :name="item.correct === '①' ? 'radio_button_unchecked' : 'close'" size="1.5em"
                                        class='checkedicon' />
                                </div>
                            </div>
                            <div style="margin-top: 10px; display: flex; flex-direction: row;align-items: center;">
                                <span style="font-weight: 700;font-size: 1.2em">해설</span>
                                <span style="margin-left: 10px;font-size: 1.2em" v-html="item.explain"></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="divider" />
            </li>
        </ul>
        <FloatingNotify :text="msg" @resetMsg="() => { msg = '' }" />
        <FloatingBtn :visible="nextBtn && !complete" text="정답 확인" @on-click="() => { testPaper(); }" bgColor="#FF4E7C"
            class="answer--txt" />
        <!-- <FloatingBtn :visible="complete" text="완료"
            @on-click="() => { nextBtn && complete ? saveResult() : testPaper(); }" bgColor="black" icon="done"
            class="answer--txt" /> -->

        <FloatingBtn :visible="complete" :text="complete && props.isLastExam ? '완료' : null"
            :bgColor="complete && props.isLastExam ? '#222222' : null"
            :icon="complete && props.isLastExam ? 'done' : null"
            @on-click="() => { nextBtn && complete ? saveResult() : testPaper(); }"
            :class="complete && props.isLastExam ? 'answer--txt' : 'answer--next'" />
    </q-page-container>
</template>


<script setup>
import { historyBack } from "@/helpers/utils"
import splash from "@/components/template/splash.vue"
import { ref, onMounted, onUnmounted, watch, defineProps, toRaw } from "vue";
import { useQuasar } from 'quasar'
import { useRouter } from "vue-router"
import { getKrtExam, getKrtProblem } from "@/api/modules/qbank";
import dataToParse from "@/helpers/qbankParser/dataParse";
import moment from "moment";
import modalLayer from '@/components/layouts/layer/modalLayer.vue';
import { DialogStore } from "@/store/modules/dialog";
import { getHeader, getQuestion, getQuestion_old, getAnswerExplain } from "@/helpers/qbankParser/qbankDataParse";
import { stripTags } from "@amcharts/amcharts5/.internal/core/util/Utils";
import { StudyStore } from "@/store/modules/study";
import { postAnswer, getLessonNext, postCornerEnd } from "@/api/modules/study";
import { getUserMain, postUserJson } from "@/api/modules/login";
import FloatingBtn from "@/components/quasar/floatingBtn.vue";
import FloatingNotify from "@/components/quasar/floatingNotify.vue";
import _ from "lodash"
import { soundEffect } from "@/helpers/soundEffect";
import customHeader from "@/components/layouts/header/header.vue";
import CusButton from "@/components/widget/CusButton.vue";

const router = useRouter();
const loadingTime = 1000;
const isLoading = ref(null);
const isProc = ref(null);
const delay = 0;
const bar = ref(null)
const answer = ref([]);
const complete = ref(false)
const studyStore = StudyStore();

const data = ref(null)
const questionHeader = ref(null);

const msg = ref('');
const nextBtn = ref(false);

let noti = null;
let problemMaps = [];
let temp = [];
let i = 0

let stage = '' // start, check, done

let cornerTime = {
    cornerLearningStartTs: null,
    cornerLearningEndTs: null,
    cornerLearningTime: 0,
}
let cornerLearningBaseTime = null;
let startTime;
let currentIdx = 0;

const props = defineProps({
    'problemIds': {
        default: []
    },
    'type': {
        default: 'wrong'
    },
    'title': {
        default: '오답노트 준비중...'
    },
    'examName': {
        default: ''
    },
    'isLastExam': {
        default: false
    },
});

const emit = defineEmits(['onClickEnd']);

const initVoca = async () => {
    // getKrtExam({
    //     version: studyStore.exprVersion, examNm: studyStore.process.exam.examCode + '_W'
    // }, (rs) => {
    //     // console.log('exam:', rs)
    //     if (rs.examMaps) {
    //         const exId = rs.examIds[0];
    //         problemMaps = rs.examMaps[exId];
    //         problemMaps.map((item) => {
    //             getKrtProblem({
    //                 version: studyStore.exprVersion, problemId: item.problemId
    //             }, initVoca)
    //         })
    //     }
    // });
    // console.log('initVoca ');
    // console.log(props.problemIds);
    if (props.problemIds && props.problemIds.length > 0) {
        let problemArrId = toRaw(props.problemIds);
        await Promise.all(
            problemArrId.map((item, index) => {
                return getKrtProblem({
                    version: item.exprVersion, problemId: item.problemId
                    // version: '1.00.01', problemId: 382222
                }, (rs) => {

                    // console.log('init', rs.content);
                    // console.log(getQuestion(rs));
                    let value = {
                        question: getHeader(rs, true),
                        problems: getQuestion_old(rs),
                        // answer: rs.content.solution.answer.detail[0].answer,
                        correct: rs.content.solution.answer.detail[0].answer,
                        explain: getAnswerExplain(rs),
                        problemId: rs.content.problemId,
                        answerStartTs: null,
                        answerEndTs: null,
                        elapsedTime: 0,
                        // correct: null,
                        answer: '',
                        reAnswer: null,
                        reCorrectFlag: null,
                        correctYn: null,
                        problemClassCode: '1',
                        reviewContents: null,
                        answerStatus: '',
                        examName: item.examName
                        // problems: styletag(dataToParse.getQuestionBody(rs)[0][0].content),
                        // answer: dataToParse.getAnswer(rs)[2].content,
                        // explain: dataToParse.getAnswerExplain(rs)[0][0].content
                    }

                    temp.push(value)
                    if (index === 0) {
                        questionHeader.value = stripTags(getHeader(rs, true));
                    }
                })
            }));

        data.value = _.sortBy(temp, 'problemId');
        // console.log(data.value)
        isLoading.value = false;
        startTime = moment();
        cornerTime.cornerLearningStartTs = moment().format('YYYY-MM-DD HH:mm:ss');
        cornerLearningBaseTime = moment();

    }
}

const testPaper = () => {
    let newData = []
    data.value.map((item, index) => {
        answer.value.map((ans) => {
            // console.log('answer', ans)
            if (index === ans.index - 1) {
                if (item.correct === ans.checked) {
                    // console.log('correct', item.correct, ans.checked)
                    let temp = {
                        ...item,
                        correctYn: true,
                        answer: ans.checked
                    }
                    return newData.push(temp)
                } else {
                    // console.log('wrong', item.correct, ans.checked)
                    let temp = {
                        ...item,
                        correctYn: false,
                        answer: ans.checked
                    }
                    return newData.push(temp)
                }
            }
        })
        // console.log(newData)
    })

    data.value = newData;

    if (answer.value.length === data.value.length) {
        nextBtn.value = false;
        complete.value = true
        setTimeout(() => {
            nextBtn.value = true;
        }, 1000)

    }
    return;
}

const saveResult = () => {
    isProc.value = true;
    let tmpData = {};
    Object.values(data.value).forEach((tmpVal, index) => {
        // tmpVal.reviewContents = isChangeHeader.value ? document.getElementById('header_box').innerHTML : null;
        // tmpVal.correctYn = tmpVal.result === null ? null : (tmpVal.result?.marking === 'right');
        // tmpVal.reCorrectYn = tmpVal.reAnswer === null ? null : tmpVal.result?.marking === 'halfRight' ? true : false;
        tmpVal.answerStatus = 'COMPLETE';
        tmpVal.completeYn = true;

        delete tmpVal.data;
        delete tmpVal.result;

        delete tmpVal.problemNo;
        delete tmpVal.analysisOrd;
        delete tmpVal.etcInfo;
        delete tmpVal.videoTime;
        delete tmpVal.relationResult;
        delete tmpVal.scrollCheck;
        delete tmpVal.relationId;
        delete tmpVal.completeVideo;

        delete tmpVal.videoUrl;
        delete tmpVal.completeVideo;
        delete tmpVal.explain;
        delete tmpVal.problems;
        delete tmpVal.question;

        tmpData = { ...tmpData, [index]: tmpVal };
    });
    emit('onClickEnd', toRaw(tmpData));

}

const selectAnswer = (index, checked) => {
    stage.value === 'check'
    let answerlist = []
    let tmpData = {
        index,
        checked
    }
    // 시간 계산 추가
    if (!data.value[index - 1].answerStartTs) {
        data.value[index - 1].answerStartTs = moment(startTime).format('YYYY-MM-DD HH:mm:ss');
    }
    data.value[index - 1].elapsedTime = data.value[index - 1].elapsedTime + moment.duration(moment().diff(startTime)).asSeconds();
    data.value[index - 1].answerEndTs = moment().format('YYYY-MM-DD HH:mm:ss');
    startTime = moment();

    if (complete.value === true) {
        return
    }

    // o가 선택된 상황에서 x를 선택한 경우, 반대 경우
    if (answer.value.length > 0 && answer.value.filter((item) => item.index === index).length > 0) {
        if (checked === '①') {
            let newAnswer = answer.value.map((item) => {
                if (item.index === index) {
                    return {
                        index: item.index,
                        checked: '①'
                    }
                }
                return item
            })
            answer.value = [...newAnswer]

        } else {
            let newAnswer = answer.value.map((item) => {
                if (item.index === index) {
                    return {
                        index: item.index,
                        checked: '②'
                    }
                }
                return item
            })
            answer.value = [...newAnswer]

        }
    } else {
        // o, x 둘 중 하나를 선택한 경우
        answerlist.push(tmpData)
    }
    answer.value = [...answer.value, ...answerlist]

    // console.log(JSON.parse(JSON.stringify(answer.value)))
}

onMounted(() => {
    soundEffect('enter');
    isLoading.value = true;
    temp = [];
    // console.log("###################################################  onMounted")
    setTimeout(() => {
        // msg.value = '어휘력 실력을 키워보아요!';
        msg.value = '수능 빈출 어휘 문제를 풀어 보세요.';
    }, [2000])
    setTimeout(() => { initVoca(); }, 1000);
})

watch(() => props.problemIds, (newValue) => {
    // console.log("###################################################  watch")
    temp = [];
    isLoading.value = true;
    // scoreBtn.value = false;
    // preBtn.value = false;
    // nextBtn.value = false;
    setTimeout(() => { initVoca(); }, 1000);
});

watch((answer), () => {
    if (answer.value.length === data.value.length) {
        // $q.notify({
        //   color: '#44444490',
        //   textColor: 'white',
        //   position: 'right',
        //   badgeStyle: { display: 'none' },
        //   timeout: 1000,
        //   message: '문제를 다 풀었어요!'
        // })
        msg.value = '문제를 다 풀었어요!';
        nextBtn.value = true;
        // noti = $q.notify({
        //   timeout: 0,
        //   message: '',
        //   multiLine: true,
        //   badgeStyle: { display: 'none' },
        //   color: 'deep-orange-6',
        //   position: 'bottom-right',
        //   actions:
        //     [{ label: '정답 확인', color: 'white', iconRight: 'arrow_forward_ios', handler: () => testPaper() }]
        // });
    }
})

watch(data, (value) => {
    // console.log(value)
})

onUnmounted(() => {
    temp = [];
    isLoading.value = true;
    noti !== null && noti();
})

</script>

<style scoped lang="scss">
.question {
    // margin-left: 120px;
    font-size: 1.5em;
    font-weight: 700;
    margin-bottom: 8px;
    // margin-top: 30px;
}

.qlist {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 40px 120px;
    height: 80%;
}

.list_item {
    display: flex;
    flex-direction: column;
    padding-top: 12px;

    .number {
        justify-content: center;
        display: flex;
        align-items: flex-start;
        margin-top: 16px;
        font-size: 1.5rem;
        font-weight: bold;
        margin-right: 24px;
    }
}

.icon_box {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.icon_circle {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    border: 1px solid #bbbbbb60;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 20px;
}

.icon_circle2 {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    background-color: #bbbbbb60;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 20px;
}

.divider {
    width: 100%;
    height: 1px;
    background-color: $divider;
    margin-top: 12px;
}

.bottom_buttons {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 60px;
    justify-content: center;
    align-items: center;
}

.button_icon {
    width: 40px;
    height: 40px;
    background-color: #bbbbbb70;
    border-radius: 50%;
}

.check_answer {
    width: calc(100% - 56px);
    background-color: $gray_200;
    border-radius: 16px;
    margin-top: 12px;
    margin-bottom: 12px;
    padding: 20px;
    margin-left: 56px;
}

.checked {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    border: 1px solid #bbbbbb60;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 20px;
    background-color: #4659FF;
}

.checked_wrong {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    border: 1px solid #bbbbbb60;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 20px;
    // background-color: $primary;
    background-color: #EF2B2A;
}

.move_to_core {
    background-color: $primary;
    padding: 10px 16px;
    border-radius: 20px;
    color: $white;
    margin-top: 20px;
    font-weight: 600;
}

.checked_small {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: 1px solid #bbbbbb60;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
    background-color: #4659FF;

    &_wrong {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        border: 1px solid #bbbbbb60;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 10px;
        background-color: #EF2B2A
    }
}

.checkedicon {
    color: #fff;
}

.uncheckedicon {
    color: #d9d9d9
}

.popup {
    width: 100%;
    background-color: $white;
    border-radius: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 50px 25px;
    min-height: 460px;
    max-height: 550px;
}

.wrong_answer_circle {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    border: 1px solid#BDBDBD;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 20px;
    background-color: #bdbdbd;
}

.marking {
    &-correct {
        background-image: url('@/assets/images/O.png');
        background-position: 50%;
        background-size: cover;
        width: 90px;
        height: 90px;
        position: absolute;
        z-index: 100;
        margin-top: -22px;
        margin-left: 0px;
    }

    &-hcorrect {
        background-image: url('@/assets/images/OX.png');
        background-position: 50%;
        width: 90px;
        height: 90px;
        position: absolute;
        z-index: 100;
        margin-top: -22px;
        margin-left: 0px;
    }

    &-wrong {
        background-image: url('@/assets/images/X.png');
        background-position: 50%;
        background-size: cover;
        width: 90px;
        height: 90px;
        position: absolute;
        z-index: 100;
        margin-top: -22px;
        margin-left: 0px;
    }

    &-fwrong {
        background-image: url('@/assets/images/XX.png');
        background-position: 50%;
        background-size: cover;
        width: 90px;
        height: 90px;
        position: absolute;
        z-index: 100;
        margin-top: -22px;
        margin-left: 0px;
    }
}
</style>
